/**
 * bootprompt.js locale configuration
 * locale : Albanian
 * author : Knut Hühne
 */

import { addLocale } from "../bootprompt";

addLocale("sq", {
  OK: "OK",
  CANCEL: "Anulo",
  CONFIRM: "Prano",
});
